import React from 'react';
import dynamicfunction from '../utils/dynamicfunction';
import Text from './Text';
import { fontSizes } from '../constants/constants';

const SarSymbol = ({color, className, size}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <Text
      weight={TextWeight.sarSymbol}
      size={size ?? fontSizes.h14}
      color={color}
      className={className}
      text={
        <>
        &#xE900;
        </>
      }
    />
  );
};

export default SarSymbol;
